import CloudUploadOutlinedIcon from '@mui/icons-material/CloudUploadOutlined';
import FolderIcon from '@mui/icons-material/Folder';
import { Box, CircularProgress, styled, Typography } from '@mui/material';
import { EColors, getColor } from 'theme';

const DEFAULT_DESCRIPTION = 'Select at least one file.';

const UploadFileIcon = styled(FolderIcon)({
    fontSize: 50,
});

const Description = styled(Typography)({
    '& > span': {
        color: getColor(EColors.v3Dark),
        fontSize: '14px',
        fontStyle: 'normal',
        fontWeight: 700,
        lineHeight: '20px',
        textDecorationLine: 'underline',
    },
});

type UploadContent = {
    isDragActive: boolean;
    description?: string;
    isUploading?: boolean;
    onUploadClick?: () => void;
};

export function UploadContent({ isDragActive, isUploading, description }: UploadContent) {
    if (isDragActive) {
        return (
            <Box width="100%" display="flex" flexDirection="column" alignItems="center" justifyContent="center">
                <CloudUploadOutlinedIcon fontSize="large" sx={{ color: getColor(EColors.pureBlack) }} />
                <Typography variant="body2">Drop the files here</Typography>
            </Box>
        );
    }

    if (isUploading) {
        return (
            <Box width="100%" display="flex" flexDirection="column" alignItems="center" justifyContent="center">
                <CircularProgress size={24} sx={{ color: getColor(EColors.pureBlack) }} />
            </Box>
        );
    }

    return (
        <>
            <UploadFileIcon />

            <Box ml={0.5}>
                <Description>
                    <span>Upload</span> or <span>drag and drop</span>
                </Description>
                <Typography fontSize="12px">{description || DEFAULT_DESCRIPTION}</Typography>
            </Box>
        </>
    );
}
